export const accordion = {
  init: function () {
    $(".accordion-item").each(function () {
      const h = $(this).find(".accordion__content").innerHeight();
      const self = $(this).hasClass("target-self") ? true : false;
      $(this).find(".accordion__content").css({ maxHeight: 0 });
      $(this)
        .find("label")
        .on("click", function (e) {
          if(!self) {
            e.preventDefault();
  
            if (!$(this).parents('.accordion-item').hasClass("opened")) {
              $(".accordion-item").removeClass("opened");
              $(".accordion-item")
                .find(".accordion__content")
                .css({ maxHeight: 0 });
              $(this)
                .parent()
                .find(".accordion__content")
                .css({ maxHeight: h + "px" });
              $(this).parents('.accordion-item').addClass("opened");
            } else {
              $(this).parent().find(".accordion__content").css({ maxHeight: 0 });
              $(this).parents('.accordion-item').removeClass("opened");
            }
          }
        });
    });
  },
};
